import { Languages } from "../../../enums/languages";

const updateVehicleModalLang = {
    "modal-title": {
        [Languages.Hebrew]: { default: "עידכון פרטי רכב בתו קיים" },
        [Languages.Arabic]: { default: "تحديث معلومات السيارة في التصريح الحالي" },
        [Languages.English]: { default: "Update Vehicle Details in Existing Permit" }
    }
};

export default updateVehicleModalLang;